import { useStore } from '@balm-ui';
import { getRouteParams } from '@yiban-shared/utils/get-route-info';
import { isDev } from '@yiban-shared/config';

export default ({ getFormDataWithDefaultParams }) =>
  async function getModelDetailDataFn(detailViewData) {
    let result = {};

    const { model, keyName, $route } = detailViewData;
    const { hasKey, keyParams } = getRouteParams({ keyName, $route });

    if (hasKey) {
      const $store = useStore();

      const params = getFormDataWithDefaultParams
        ? await getFormDataWithDefaultParams('detail-view', keyParams, {
            actionType: 'get',
            keyParams,
            ...detailViewData
          })
        : keyParams;

      isDev && console.info('getModelDetailDataFn', model, params);

      result = await $store.$getModelDetail(model, params);
    }

    return result;
  };
